import { createAction, createSlice } from "@reduxjs/toolkit";

export const fetchWorkflowAnalyticsRequest = createAction("workflowAnalytics/fetchWorkflowAnalyticsRequest");

const initialState = {
  analytics: null,
  loading: false,
  error: null,
  lastParams: null
};

const workflowAnalyticsSlice = createSlice({
  name: "workflowAnalytics",
  initialState,
  reducers: {
    fetchWorkflowAnalyticsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWorkflowAnalyticsSuccess(state, action) {
      state.loading = false;
      state.analytics = action.payload.analytics;
      state.lastParams = action.payload.params;
      state.error = null;
    },
    fetchWorkflowAnalyticsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowAnalytics(state) {
      state.analytics = null;
      state.loading = false;
      state.error = null;
      state.lastParams = null;
    }
  }
});

export const {
  fetchWorkflowAnalyticsStart,
  fetchWorkflowAnalyticsSuccess,
  fetchWorkflowAnalyticsFailure,
  clearWorkflowAnalytics
} = workflowAnalyticsSlice.actions;

export default workflowAnalyticsSlice.reducer;
